import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import api from "../api/api";

function AdminMedicineExcelUpload() {
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadInfo, setUploadInfo] = useState(null);

  // NEW: stock + sales summary
  const [stockSummary, setStockSummary] = useState(null);
  const [salesSummary, setSalesSummary] = useState(null);

  const [cleanInfo, setCleanInfo] = useState(null);

  const handleBack = () => navigate(-1);

  const formatMoney = (v) => {
    if (v === null || v === undefined) return "₹0.00";
    try {
      return Number(v).toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
      });
    } catch {
      return `₹${v}`;
    }
  };

  const safeFixed = (num) =>
    num ? Number(num).toFixed(2) : "0.00";

  const formatNumber = (v) => {
    if (v === null || v === undefined) return "0";
    try {
      return Number(v).toLocaleString("en-IN");
    } catch {
      return String(v);
    }
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected || null);
    setMessage("");
    setUploadInfo(null);
    setCleanInfo(null);
    setStockSummary(null);
    setSalesSummary(null);
  };

  // Upload medicine Excel
  const handleUpload = async () => {
    if (!file) return setMessage("Please select a file first.");

    setIsUploading(true);
    setMessage("Uploading...");
    setUploadInfo(null);
    setCleanInfo(null);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post("medicine/upload-excel/", formData);
      setUploadInfo(res.data);
      setMessage("Upload successful ✅");
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Upload failed (see console)"
      );
    } finally {
      setIsUploading(false);
    }
  };

  // Clean duplicate medicines
  const handleCleanDuplicates = async () => {
    setMessage("");
    setCleanInfo(null);

    try {
      const res = await api.post("medicine/clean-duplicates/");
      setCleanInfo(res.data);
      setMessage("Duplicate cleaning completed ✅");
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Failed to clean duplicates"
      );
    }
  };

  // Download stock Excel
  const handleDownloadStock = async () => {
    try {
      const res = await api.get("medicine/download-stock/", {
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "medicine_stock.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Failed to download stock file"
      );
    }
  };

  // 📊 STOCK SUMMARY BUTTON
  const handleViewStockSummary = async () => {
    setMessage("");
    setSalesSummary(null); 
    setStockSummary(null);
    try {
      const res = await api.get("medicine/stock-summary/");
      setStockSummary(res.data);
      setMessage("Medicine stock summary loaded ✅");
    } catch (error) {
      console.error(error);
      setMessage("Failed to load medicine stock summary");
    }
  };

  // 💰 SALES SUMMARY BUTTON
  const handleViewSalesSummary = async () => {
    setMessage("");
    setStockSummary(null);
    setSalesSummary(null);
    try {
      const res = await await api.get("medicine-sales-summary/");
      setSalesSummary(res.data);
      setMessage("Medicine sales summary loaded ✅");
    } catch (error) {
      console.error(error);
      setMessage("Failed to load medicine sales summary");
    }
  };
const handleResetSales = async () => {
  if (!window.confirm("Are you sure? This will reset ALL sales to 0!")) return;

  try {
    await api.post("/reset-sales/");
    alert("All sales reset to 0 ✔");
    
    // Reload summaries if needed
    setSalesSummary(null);
    setStockSummary(null);
  } catch (err) {
    console.error(err);
    alert("Failed to reset sales ❌");
  }
};


  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.headerRow}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={styles.headerIcon}>💊</span>
            <h2 style={styles.title}>Upload Medicine Excel</h2>
          </div>
          <button onClick={handleBack} style={styles.logoutButton}>
            BACK
          </button>
        </div>

        {/* File input */}
        <div style={{ marginBottom: 16 }}>
          <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
          {file && (
            <p style={styles.smallText}>
              Selected: <strong>{file.name}</strong>
            </p>
          )}
        </div>

        {/* Buttons */}
        <div style={styles.buttonRow}>
          <button
            onClick={handleUpload}
            disabled={!file || isUploading}
            style={{
              ...styles.buttonPrimary,
              opacity: !file || isUploading ? 0.6 : 1,
            }}
          >
            {isUploading ? "Uploading..." : "⬆ Upload Excel"}
          </button>

          <button
            onClick={handleViewStockSummary}
            style={styles.buttonSecondary}
          >
            📊 View Stock Summary
          </button>

          <button
            onClick={handleViewSalesSummary}
            style={styles.buttonSecondary}
          >
            💰 View Sales Summary
          </button>

          <button
            onClick={handleCleanDuplicates}
            style={styles.buttonSecondary}
          >
            🧹 Clean Duplicate Medicines
          </button>

          <button
            onClick={handleDownloadStock}
            style={styles.buttonSecondary}
          >
            ⬇ Download Stock Excel
          </button>
         <button
  className="btn btn-danger"
  onClick={handleResetSales}
>
  🔄 Reset All Sales
</button>

        </div>

        {/* Status message */}
        {message && <p style={styles.message}>{message}</p>}

        {/* Upload summary (optional, like surgical) */}
        {uploadInfo && (
          <div style={styles.infoBox}>
            <h4>Upload Summary</h4>
            <p>
              <strong>Created:</strong> {formatNumber(uploadInfo.created)}
            </p>
            <p>
              <strong>Updated:</strong> {formatNumber(uploadInfo.updated)}
            </p>
            <p>
              <strong>Total Items:</strong>{" "}
              {formatNumber(uploadInfo.total_items)}
            </p>
            <p>
              <strong>Total Stock Units:</strong>{" "}
              {formatNumber(uploadInfo.total_stock_units)}
            </p>
            <hr style={styles.hr} />
            <p>
              <strong>Total Purchase Value:</strong>{" "}
              {formatMoney(uploadInfo.total_purchase_value)}
            </p>
            <p>
              <strong>Total Sale Value:</strong>{" "}
              {formatMoney(uploadInfo.total_sale_value)}
            </p>
            <p>
              <strong>Profit:</strong>{" "}
              {formatMoney(uploadInfo.total_profit_value || 0)}{" "}
              {safeFixed(uploadInfo.total_profit_percent)}%
            </p>
          </div>
        )}

        {/* 📊 STOCK SUMMARY CARD */}
        {stockSummary && (
          <div style={styles.infoBox}>
            <h4>Medicine Stock Summary</h4>
            <p>
              <strong>Total Medicines:</strong>{" "}
              {formatNumber(stockSummary.total_items)}
            </p>
            <p>
              <strong>Total Stock Units:</strong>{" "}
              {formatNumber(stockSummary.total_stock_units)}
            </p>

            <hr style={styles.hr} />

            <p>
              <strong>Total Purchase Value:</strong>{" "}
              {formatMoney(stockSummary.total_purchase_value)}
            </p>
            <p>
              <strong>Total Sale Value:</strong>{" "}
              {formatMoney(stockSummary.total_sale_value)}
            </p>
            <p>
              <strong>Total Profit:</strong>{" "}
              {formatMoney(stockSummary.total_profit_value)} (
              {safeFixed(stockSummary.total_profit_percent)}%)
            </p>

            <hr style={styles.hr} />
            <p>
              <strong>OTC Items:</strong>{" "}
              {formatNumber(stockSummary.otc_items_count)} | Stock:{" "}
              {formatNumber(stockSummary.otc_total_stock)} | Sale Value:{" "}
              {formatMoney(stockSummary.otc_sale_value)}
            </p>
            <p>
              <strong>Prescription Items:</strong>{" "}
              {formatNumber(stockSummary.rx_items_count)} | Stock:{" "}
              {formatNumber(stockSummary.rx_total_stock)} | Sale Value:{" "}
              {formatMoney(stockSummary.rx_sale_value)}
            </p>
          </div>
        )}

        {/* 💰 SALES SUMMARY CARD */}
        {salesSummary && (
          <div style={styles.infoBox}>
            <h4>Medicine Sales Summary</h4>
            <p>
              <strong>Total Orders (paid):</strong>{" "}
              {formatNumber(salesSummary.total_orders)}
            </p>
            <p>
              <strong>Delivered Orders:</strong>{" "}
              {formatNumber(salesSummary.delivered_orders)}
            </p>
            <p>
              <strong>Pending Orders:</strong>{" "}
              {formatNumber(salesSummary.pending_orders)}
            </p>
            <p>
              <strong>Cancelled Orders:</strong>{" "}
              {formatNumber(salesSummary.cancelled_orders)}
            </p>

            <hr style={styles.hr} />
            <p>
              <strong>Total Revenue:</strong>{" "}
              {formatMoney(salesSummary.total_revenue)}
            </p>
            <p>
              <strong>Delivered Revenue:</strong>{" "}
              {formatMoney(salesSummary.delivered_revenue)}
            </p>
            <p>
              <strong>Pending Revenue:</strong>{" "}
              {formatMoney(salesSummary.pending_revenue)}
            </p>
            <p>
              <strong>Cancelled Revenue:</strong>{" "}
              {formatMoney(salesSummary.cancelled_revenue)}
            </p>
            <p>
              <strong>Average Order Value:</strong>{" "}
              {formatMoney(salesSummary.average_order_value)}
            </p>

            <hr style={styles.hr} />
            <p>
              <strong>OTC Revenue:</strong>{" "}
              {formatMoney(salesSummary.otc_revenue)}
            </p>
            <p>
              <strong>Prescription Revenue:</strong>{" "}
              {formatMoney(salesSummary.prescription_revenue)}
            </p>
          </div>
        )}

        {/* Duplicate cleaning summary */}
        {cleanInfo && (
          <div style={styles.infoBox}>
            <h4>Duplicate Cleaning Summary</h4>
            <p>
              <strong>Duplicate Name Groups:</strong>{" "}
              {formatNumber(cleanInfo.duplicate_name_groups)}
            </p>
            <p>
              <strong>Records Removed:</strong>{" "}
              {formatNumber(cleanInfo.records_removed)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    display: "flex",
    justifyContent: "center",
    paddingTop: 40,
    paddingBottom: 40,
    background: "#f4f5fb",
    minHeight: "100vh",
  },
  card: {
    width: "90%",
    maxWidth: 1000,
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    padding: 24,
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  headerIcon: { fontSize: 28 },
  title: { fontSize: 22, fontWeight: "bold" },
  buttonRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 12,
  },
  buttonPrimary: {
    padding: "10px 18px",
    borderRadius: 8,
    border: "none",
    background: "#2a7ae4",
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: "bold",
  },
  buttonSecondary: {
    padding: "10px 18px",
    borderRadius: 8,
    border: "1px solid #999",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: "bold",
  },
  logoutButton: {
    padding: "8px 16px",
    background: "#000",
    color: "#fff",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: "bold",
  },
  message: { fontWeight: "bold", marginBottom: 12 },
  infoBox: {
    background: "#eef3ff",
    padding: 14,
    marginTop: 12,
    borderRadius: 10,
    border: "1px solid #cdd9ff",
  },
  hr: { borderTop: "1px solid #ccd5ff", margin: "10px 0" },
  smallText: { fontSize: 12, color: "#555" },
};

export default AdminMedicineExcelUpload;
